module.exports = __webpack_public_path__ + "img/NiklasArndt_140x140_rund.65610b84.jpg";